/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React, {PropsWithChildren} from 'react';
import {UpdateContextConfig, ContextShape} from "../../util/interfaces";
import User from "../../models/userModel";
import {ControlVariant, ThemeProvider, ThemeShape, voidFunction} from '@dvrd/dvr-controls';
import merge from 'lodash/merge';

const defaultContext: ContextShape = {
    userContext: {
        user: null as User | null,
        onChange: voidFunction,
    },
    theme: {
        onChange: voidFunction,
        baseColor: '',
        borderColor: '',
        contrastColor: '',
        controlVariant: ControlVariant.SIMPLE,
    },
    onChangeContext: voidFunction,
}

export const AppContext = React.createContext(defaultContext);

interface State {
    context: ContextShape;
}

export class AppContextProvider extends React.Component<PropsWithChildren<any>, State> {
    constructor(props: PropsWithChildren<any>) {
        super(props);
        const context: ContextShape = merge({}, defaultContext, {
            onChangeContext: this.onChangeContext,
            theme: {
                onChangeTheme: this.onChangeTheme
            }
        });
        this.state = {context};
    }

    onChangeTheme = (style?: ThemeShape | null, callback?: VoidFunction) => {
        const context = this.getContext(), theme = Object.assign({}, context.theme);
        if (style) {
            if (style.baseColor) theme.baseColor = style.baseColor;
            if (style.contrastColor) theme.contrastColor = style.contrastColor;
        } else {
            theme.baseColor = '#434b50';
            theme.contrastColor = 'white';
        }
        context.theme = theme;
        this.setContext(context, callback);
    };

    onChangeContext = (config: UpdateContextConfig, callback?: VoidFunction) => {
        const {user} = config;
        const context = this.getContext();
        if (user !== undefined) context.userContext = Object.assign({}, context.userContext, {user});
        this.setContext(context, callback);
    };

    private getContext = (): ContextShape => merge({}, this.state.context);

    private setContext = (context: ContextShape, callback?: VoidFunction) => {
        this.setState({context}, callback);
    };

    render = () => {
        const {context} = this.state;
        return (
            <ThemeProvider theme={context.theme}>
                <AppContext.Provider value={context}>
                    {this.props.children}
                </AppContext.Provider>
            </ThemeProvider>
        )
    };
}